/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum pagingEntityEnum {
  JOURNEY = 'Journey',
  ROUTE = 'Route',
  ROUTE_GROUP = 'RouteGroup',
}
